// @ts-nocheck
import PropTypes from 'prop-types';
import { createContext, useContext, useState, useEffect } from 'react';

// Create the context
const OnlineStatusContext = createContext(undefined);

// Custom hook to use the context
// eslint-disable-next-line react-refresh/only-export-components
export const useOnlineStatus = () => {
  const context = useContext(OnlineStatusContext);
  if (context === undefined) {
    throw new Error('useOnlineStatus must be used within OnlineStatusProvider');
  }
  return context;
};

// Provider component
export const OnlineStatusProvider = ({ children }) => {
  const [isOnline, setIsOnline] = useState(navigator?.onLine);

  useEffect(() => {
    const handleOnline = () => {
      console.log('[OnlineStatus] Device is online');
      setIsOnline(true);
    };

    const handleOffline = () => {
      console.log('[OnlineStatus] Device is offline');
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Log initial status
    console.log(
      '[OnlineStatus] Initial status:',
      navigator.onLine ? 'online' : 'offline'
    );

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const value = {
    isOnline
  };

  return (
    <OnlineStatusContext.Provider value={value}>
      {children}
    </OnlineStatusContext.Provider>
  );
};

OnlineStatusProvider.propTypes = {
  children: PropTypes.node.isRequired
};

// Default export for convenience
export default OnlineStatusProvider;
